export const productOptionFragment = `
	fragment ProductOption on ProductOption {
		id
		name
		values
	}
`;
